'use client';

import {useTranslations} from 'next-intl';
import {ChangeEvent, useMemo, useState} from 'react';
import {Checkbox} from '../../../../../../components/design-system';
import useShop from '../../../../../../stores/shop/useContext';
import useFilters from '../hooks/useFilters';
import FilterModal from './FilterModal';

export default function FilterCharacteristic() {
  const t = useTranslations('shop');

  const {facets} = useShop((s) => s);
  const {filters, set} = useFilters();

  const [selected, setSelected] = useState(filters.characteristic || []);

  const appliedValue = useMemo(() => {
    if (!filters.characteristic || filters.characteristic.length === 0) {
      return undefined;
    }
    const facet = facets.characteristics
      .reduce((acc, curr) => [...acc, curr, ...curr.children], [])
      .find((f) => f.slug === filters.characteristic![0]);

    return (
      `${facet?.name || filters.characteristic[0]}` +
      (filters.characteristic.length > 1
        ? ' +' + (filters.characteristic.length - 1)
        : '')
    );
  }, [filters.characteristic]);

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    if (selected.includes(event.target.value)) {
      setSelected((s) =>
        Array.from(new Set(s.filter((i) => i !== event.target.value))),
      );
      return;
    }
    setSelected((s) => Array.from(new Set([...s, event.target.value])));
  }

  function handleApply() {
    set({characteristic: selected});
  }

  return (
    <FilterModal
      label={t('filter.characteristic.title')}
      appliedValue={appliedValue}
      onApply={() => handleApply()}
    >
      <form className="tw-px-4 tw-space-y-2">
        {(facets.characteristics || []).map((item) => (
          <div key={item.id}>
            <Checkbox
              name="characteristic"
              onChange={handleChange}
              checked={selected.includes(item.slug)}
              value={item.slug}
              label={item.name}
              reverse
            />
            {item.children.map((child) => (
              <div key={child.id} className="tw-pl-4 tw-mt-2">
                <Checkbox
                  name="characteristic"
                  onChange={handleChange}
                  checked={selected.includes(child.slug)}
                  value={child.slug}
                  label={child.name}
                  reverse
                />
              </div>
            ))}
          </div>
        ))}
      </form>
    </FilterModal>
  );
}
